import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

export const PeriodList: PeriodProps[] = [
  { value: 2, id: 0 },
  { value: 4, id: 1 },
  { value: 8, id: 2 },
  { value: 12, id: 3 },
  { value: 24, id: 4 },
];

export interface PeriodProps {
  value: number | undefined;
  id: number | undefined;
  error?: boolean | undefined;
}

// Define the initial state using that type
const initialState: PeriodProps = {
  id: PeriodList[PeriodList.length - 1].id,
  value: PeriodList[PeriodList.length - 1].value,
  error: false,
};

export const periodSlice = createSlice({
  name: 'period',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setPeriod: (state, action: PayloadAction<PeriodProps | null>) => {
      state.value = action.payload?.value;
      state.id = action.payload?.id;
      state.error = !action.payload;
    },
  },
});

export const { setPeriod } = periodSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectPeriodOption = (state: RootState) => state.period;

export default periodSlice.reducer;
